import { compCssMappersDomApplier } from './compCssMappersDomApplier'
import { CompCssMappersFeature } from './compCssMappers.types'
import { compCssMappers } from './compCssMappersCompNode'
import { compStyles } from '../styleBased/compStylesCompNode'
import type { NativeExtension, NativeExtensions } from '@wix/thunderbolt-components-native'
import type { BeckyModel } from '@wix/thunderbolt-becky-root'
import { uiTypeCompNode } from './uiTypeCompNode'
import { themeVariants } from '../styleBased/themeVariantsCompNode'
import { cssCarmiMappers } from './cssCarmiMappers'
// This is temporary until all carmi mappers will be migrated to native
import { hasNativeOverrideMapper } from '@wix/thunderbolt-components/src/mappers'

type InitMappers = {
	initMappers: (
		componentsMappers: BeckyModel['componentsMappers'],
		isExperimentOpen: (experimentName: keyof BeckyModel['experiments']) => boolean
	) => void
}

export const compCssMappersFeature: CompCssMappersFeature & InitMappers = {
	experimentName: 'specs.thunderbolt.compCssMappers_catharsis',
	// @ts-ignore - The renderableNodes are updated in the bootstrap using the initMappers function
	renderableNodes: { themeVariants },
	// @ts-ignore - The renderableNodes are updated in the bootstrap using the initMappers function
	intermediateNodes: { compStyles },
	dataMaps: [
		'document_data',
		'component_properties',
		'design_data',
		'theme_data',
		'behaviors_data',
		'connections_data',
	],
	domApplier: compCssMappersDomApplier,
	initMappers: (componentsMappers, isExperimentOpen) => {
		const extensionsPerType = Object.entries(componentsMappers)
			.filter(
				([componentType]) =>
					hasNativeOverrideMapper(componentType, isExperimentOpen) || !cssCarmiMappers.has(componentType)
			)
			.reduce(
				(acc, [componentType, { css, selectorToCss, uiType }]) => {
					if (css) {
						acc.css[componentType] = css as NativeExtension
					}
					if (selectorToCss) {
						acc.selectorToCss[componentType] = selectorToCss as NativeExtension
					}
					if (uiType) {
						acc.uiType[componentType] = uiType as NativeExtension
					}
					return acc
				},
				{
					css: {} as NativeExtensions['extensions'],
					selectorToCss: {} as NativeExtensions['extensions'],
					uiType: {} as NativeExtensions['extensions'],
				}
			)
		const { renderableNodes, intermediateNodes } = compCssMappersFeature
		renderableNodes.compCssMappers = compCssMappers({
			name: 'css',
			extensions: extensionsPerType.css,
		})

		intermediateNodes.uiType = uiTypeCompNode({
			name: 'uiType',
			extensions: extensionsPerType.uiType,
		})
	},
}
